/* eslint-disable multiline-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'


const config = {
  types: ['multimedia'],
  modifiers: [
    {
      title: 'lg',
      isDefault: true
    },
    'sm'
  ]
}
export default function Multimedia(props) {
  let { data, isOpen, sm, onCloseClick, ...rest } = props
  data = data || {}
  onCloseClick = onCloseClick || data.onCloseClick
  isOpen = isOpen || data.isOpen


  return (
    <div
      {...rest}
      aria-hidden={isOpen ? 'false' : 'true'}
      className={`mdn-Modal mdn-Modal--lg mdn-Modal--multimedia
      ${isOpen ? ' mdn-isOpen' : ''} `}
    >
      <div className="mdn-Modal-content">
        <div className="mdn-Modal-header">
          <button
            onClick={onCloseClick}
            aria-label="Button close modal"
            role="button"
            className="mdn-Button-header-close mdn-Button mdn-Button--icon mdn-Button--secondaryInverse"
          >
            <i
              className="mdn-Icon-fechar mdn-Icon--sm"
              aria-label="Fechar modal"
            ></i>
          </button>
        </div>
        <div className="mdn-Divider mdn-Divider--default"></div>
        <div className="mdn-Modal-body">{data.content}</div>
      </div>
    </div>
  )
}

Multimedia.propTypes = {
  data: PropTypes.shape({
    header: PropTypes.node,
    buttonProps: PropTypes.object,
    content: PropTypes.node,
    footer: PropTypes.node,
    isOpen: PropTypes.bool,
    sm: PropTypes.object,
    onCloseClick: PropTypes.func
  })
}
